<template>
  <div style="height:100vh" class="d-flex flex-column justify-space-between">
    <div class="login" style="padding:50px 0 15px 0;margin:auto;">
    <v-card class="container">
      <div class="title">
        <v-img :src="imageUrl" max-height="90" max-width="130" contain class="align-self-stretch"></v-img>
        <div>
          <v-card-title class="venue">{{ VENUENAME[venue] }}</v-card-title>
          <v-card-subtitle class="subtitle">Teller Terminals Sign-In</v-card-subtitle>
        </div>
      </div>
      Username *
      <v-text-field
        v-model="username"
        @focus="handleUsernameFocus"
        outlined
       
        placeholder="Enter your Username"
        :name="Math.random()"
        color="textinput"
      />
      Password *
      <v-text-field
        :type="showPassword ? 'text' : 'password'"
        v-model="password"
        outlined
        placeholder="Enter your password"
        @focus="handlePasswordFocus"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showPassword = !showPassword"
        autocomplete="new-password"
        :error-messages="warningError"
        :name="Math.random()"
        @keydown="warningError=''"
        color="textinput"
      />
      
      <v-btn block  x-large elevation="0" @click="register" :disabled="!username" :loading="signingIn" color="bmbtncolor" class="loginButton white--text">SIGN IN</v-btn>
    </v-card>
  </div>
    <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="input"/>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import SimpleKeyboard from '../components/SimpleKeyboard'
import { VENUENAME } from '../common/constants.js'
import { mapGetters } from 'vuex'
  export default {
    props: {
      callback: Function,
      id: String,
      venue: String,
      imageUrl: String
    },
    components: {
      SimpleKeyboard
    },
    data () {
      return {
        username: '',
        password: '',
        selectedInput: null,
        showPassword: false,
        VENUENAME,
        warningError: null,
        signingIn:false
      }
    },
    computed: {
      ...mapGetters(["getVenueName"]),
      input: {
        get () {
          return this.selectedInput === 'username' ? this.username : this.password
        },
        set () {
        }
      }
    },
    methods: {
      async register() {
        this.signingIn = true
        try {
          let paddedPassword = this.password
          if (paddedPassword.length < 6) {
            const length = 6 - paddedPassword.length
            const padding = new Array(length + 1).join('*')
            paddedPassword = paddedPassword + padding
          }
          const cred = await Auth.signIn({
            username: this.username,
            password: paddedPassword,
          })
          if (cred.challengeName === "NEW_PASSWORD_REQUIRED") {
            Auth.signOut()
            this.$router.push({ path: `/verify/?username=${this.username}&authstate=NEW_PASSWORD_REQUIRED`,})
          }

          const userGroups = cred.signInUserSession.accessToken.payload['cognito:groups'] || ''
          const userMainGroup = userGroups[0] || ''
          this.signingIn = false
          if(this.getVenueName !== userMainGroup && userMainGroup !== 'Betmakers' ){
            this.warningError = 'User has no access to current venue'
            this.callback(false)
          }else{
            this.callback(true)
          }      
         
        } catch (error) {
          this.warningError = error.message
          this.signingIn = false
        }
      },
      handleUsernameFocus() {
        this.selectedInput = 'username'
      },
      handlePasswordFocus() {
        this.selectedInput = 'password'
      },
      onChange(input) {
        if (this.selectedInput === 'username') {
          this.username = input
        }
        if (this.selectedInput === 'password') {
          this.password = input
        }
      },
      onKeyPress() {
      },
      onInputChange() {
      }
    }
  }
</script>

<style scoped lang="sass">
.login
    display: flex
    justify-content: center
    align-items: center

button[class^="Button__button"]
  background-color: #057faf

a
  color: #057faf

.container
  max-width: 500px
  padding: 20px 50px

.loginButton
  float: right

.venue
  text-transform: capitalize

.title
  display: flex
  align-items: center
  margin-bottom: 20px

.subtitle
  display: flex
  justify-content: center
</style>